<template>
  <Header v-on:setOverlay="setOverlay" />
  <transition name="fade">
    <router-view :key="$route.fullPath" v-on:setOverlay="setOverlay" />
  </transition>
  <Footer />
</template>
<script>
import "@/assets/styles/index.scss";
// import { useRoute } from "vue-router";
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
// import { onMounted } from 'vue';

export default {
  components: {
    Header,
    Footer
  },
  setup() {
    const setOverlay = isOverlay => {
      const scrollWidth = window.innerWidth - document.body.clientWidth;

      document.body.scrollHeight - window.innerHeight > 0 && isOverlay
        ? document.body.setAttribute(
            "style",
            `${document.body.getAttribute("style") ||
              ""} margin-right:${scrollWidth}px;`
          )
        : document.body.setAttribute(
            "style",
            `${document.body.getAttribute("style") &&
              document.body
                .getAttribute("style")
                .replace(` margin-right:${scrollWidth}px;`, "")}`
          );

      isOverlay &&
        document.body.setAttribute(
          "class",
          `${document.body.getAttribute("class") || ""} overlay`
        );
      !isOverlay &&
        document.body.setAttribute(
          "class",
          `${document.body.getAttribute("class") &&
            document.body.getAttribute("class").replace(" overlay", "")}`
        );
      /*
            document.body.scrollHeight - window.innerHeight > 0 && isOverlay
            ? document.body.setAttribute("class", `${document.body.getAttribute("class") || ''} scroll`) 
            : document.body.setAttribute("class", `${document.body.getAttribute("class") && document.body.getAttribute("class").replace(" scroll", "")}`);
            */
      /*
            document.body.scrollHeight - window.innerHeight > 0 && isOverlay
            ? document.body.setAttribute("style", `${document.body.getAttribute("style") || ''} padding-left:${}`) 
            : document.body.setAttribute("style", `${document.body.getAttribute("style") && document.body.getAttribute("style").replace(` padding-left:${}`, "")}`);
            */
    };
    return {
      setOverlay
    };
  }
};
</script>
<style lang="scss" scope>
@use "@/assets/styles/settings/_variables.scss";
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}
.fade-enter-active {
  transition-delay: 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

main {
  min-height: calc(100vh - (417px + 67px));
}
/*
@media (min-width: 992px) {
  main {
    min-height: calc(100vh - (302px + 67px));
  }
}*/
@media (min-width: 1200px) {
  main {
    min-height: calc(100vh - (388px + 67px));
  }
}
/*
::-webkit-scrollbar {
  width: variables.$scrollbar-width;
}
::-webkit-scrollbar-track {
  background: variables.$track-color;
}
::-webkit-scrollbar-thumb {
  background: variables.$scroll-thumb;
}
::-webkit-scrollbar-thumb:hover {
  background: variables.$scroll-thumb-hover;
}
*/
</style>
